var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainHomeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4067 16.3467C19.3355 15.186 18.0355 14.2597 16.5887 13.6262C15.1418 12.9927 13.5795 12.6656 12 12.6656C10.4206 12.6656 8.85824 12.9927 7.41141 13.6262C5.96458 14.2597 4.66461 15.186 3.59337 16.3467C3.42744 16.5292 3.33484 16.7667 3.33337 17.0133V21.0133C3.33688 21.2762 3.44378 21.5272 3.63094 21.7118C3.8181 21.8965 4.07045 22 4.33337 22H19.6667C19.9319 22 20.1863 21.8946 20.3738 21.7071C20.5614 21.5196 20.6667 21.2652 20.6667 21V17C20.662 16.7579 20.5696 16.5258 20.4067 16.3467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3333C14.5774 11.3333 16.6667 9.244 16.6667 6.66667C16.6667 4.08934 14.5774 2 12 2C9.42271 2 7.33337 4.08934 7.33337 6.66667C7.33337 9.244 9.42271 11.3333 12 11.3333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHomeUser);
export default __webpack_public_path__ + "static/media/mainHomeUser.707aa02f200ac3a1fd77133d72a437d4.svg";
export { ForwardRef as ReactComponent };